import React, { useEffect, useState } from 'react';
import { Container, Row, Col, FormInput, FormGroup, Form, Button, FormSelect, Card } from 'shards-react';
import PageTitle from '../../../components/common/PageTitle';
import Input from '../../../components/UI/Input/Input';
import Select from '../../../components/UI/Select/Select';
import useForm from './useForm';
import { useTranslation } from 'react-i18next';
import AutoComplete from '../../../components/UI/AutoComplete/AutoComplete';
import LinearProgress from '@material-ui/core/LinearProgress';
import TextArea from '../../../components/UI/TextArea/TextArea';
import ImageUploader from '../../../components/UI/ImageUploader/ImageUploader';
import PdfUploader from '../../../components/UI/PdfUploader/PdfUploader';
import { CardHeader, Chip, Avatar } from '@material-ui/core';
import { getFile } from '@opu/utils';
import './style.css';
const DetailsBook = () => {
  const { back, field, formState } = useForm();
  const { t, i18n } = useTranslation();

  const authors = (authors = []) => {
    return authors.map((author) => (
      <Chip
        avatar={
          <Avatar alt={author.name} src={author.image ? getFile('author', author.image) : '/assets/images/author_avatar.png'} />
        }
        label={author.name}
        variant="outlined"
      />
    ));
  };

  const categories = (categories = []) => {
    return categories.map((category) => (
      <Chip className="category-chip-container" label={category.name} component="a" variant="outlined" />
    ));
  };

  return (
    <Container fluid className="main-content-container px-4 pb-4">
      <Row noGutters className="page-header py-4">
        <PageTitle sm="4" title={t('book.title.details')} subtitle={t('book.subTitle')} className="text-sm-left" />
      </Row>

      <Row>
        <Col>
          <Row>
            <div className="col-md-12">
              <Card className="mb-4 py-3 px-4 ">
                <Row>
                  <div className="col-lg-9">
                    <h4 className="title">{formState.inputValues.title} </h4>
                    <hr className="hr-container" />
                    <div className="attribute-container">
                      <span className="title-container">{t('label.ISBN')} : </span>
                      {formState.inputValues.ISBN}
                    </div>
                    <div className="attribute-container">
                      <span className="title-container">{t('label.authors')} :</span>
                      {formState.inputValues.authors.length > 0 && (
                        <span className="authors"> {authors(formState.inputValues.authors)} </span>
                      )}
                    </div>
                    <div className="attribute-container">
                      <span className="title-container">{t('label.categories')} :</span>
                      {formState.inputValues.categories.length > 0 && (
                        <span className="categories"> {categories(formState.inputValues.categories)} </span>
                      )}
                    </div>
                    <div className="attribute-container">
                      <span className="title-container">{t('label.pages')} : </span>
                      {formState.inputValues.pages}
                    </div>
                    <div className="attribute-container">
                      <span className="title-container">{t('label.publicationNumber')} : </span>
                      {formState.inputValues.publicationNumber}
                    </div>
                    <div className="attribute-container">
                      <span className="title-container">{t('label.editionNumber')} : </span>
                      {formState.inputValues.editionNumber}
                    </div>
                    <div className="attribute-container">
                      <span className="title-container">{t('label.publishingHouse')} : </span>
                      {formState.inputValues.publishingHouse}
                    </div>
                    <div className="attribute-container">
                      <span className="title-container">{t('label.releaseDate')} : </span>
                      {formState.inputValues.releaseDate}
                    </div>
                  </div>
                  <div className="col-lg-3 left-container-book-details">
                    <img className="image-book" alt="" src={getFile('book', formState.inputValues.cover)} />
                  </div>
                </Row>
              </Card>
            </div>

            <div className="col-md-12 ">
              <Card className="mb-4 py-5 px-4">
                <div className="title-container">{t('label.abstract')} : </div>
                <hr className="hr-container" />
                <div className="book-details-text">{formState.inputValues.abstract} </div>
              </Card>
              <Card className="mb-4 py-5 px-4">
                <div className="title-container">{t('label.summary')} : </div>
                <hr className="hr-container" />
                <div className="book-details-text">{formState.inputValues.summary} </div>
              </Card>
            </div>
          </Row>

          <Col md="12" className="d-flex justify-content-end">
            <Button theme="info" onClick={() => back()}>
              {t('annuler')}
            </Button>
          </Col>
        </Col>
      </Row>
    </Container>
  );
};

export default DetailsBook;
